// eslint-disable-next-line @tseslint/typedef, @tseslint/no-unnecessary-type-assertion
export const PROJECT_ROLE_RESOURCE = "project" as const;
// eslint-disable-next-line @tseslint/typedef
export const PROJECT_ROLES = {
  overview: "project_overview",
  settingsView: "project_setting_view",
  admin: "project_admin",
  restrictedView: "project_restricted_view",
  edit: "project_edit",
  create: "project_create",
  view: "project_view",
  notificationCreate: "project_notification_create",
  notificationUpdate: "project_notification_update",
  settingsEdit: "project_setting_edit",
  tab: "project_tab",
  notificationAdmin: "project_notification_admin",
  "delete": "project_delete"
} as const;
export type ProjectRole = typeof PROJECT_ROLES[keyof typeof PROJECT_ROLES];

const allProjectRoles: string[] = Object.values(PROJECT_ROLES) as string[];

export function isProjectRole (role: string): role is ProjectRole {
  return allProjectRoles.includes(role);
}
